export default __webpack_public_path__ + "static/media/svg-png.8e0bcaf2.png";